import { Folder } from "lucide-react";
import { createLucideIcon } from "./createLucideIcon";

export const FolderIcon = createLucideIcon(Folder);
